import type { DefaultError, OmitKeyof, QueryObserverOptions, VueQueryPluginOptions } from '@tanstack/vue-query'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import * as devalue from 'devalue'

export const serializer = 'devalue'

/**
 * `satisfies` rather than a type annotation: annotating with the `Record<string, …>` widened every
 * preset to `QueryObserverOptions<unknown>`, so spreading one into `queryOptions()` dragged in an
 * `unknown` data type and broke the overload at the call site.
 */
export const queryPresets = {
  longLivedWithSSdevalue: {
    gcTime: 10 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 5 * 60 * 1000,
    retry: false,
    experimental_prefetchInRender: true,
    structuralSharing: (oldData: unknown, newData: unknown) => {
      if (devalue.stringify(oldData) === devalue.stringify(newData)) {
        return oldData
      }
      return newData
    },
  },
  longLivedWithoutSS: {
    gcTime: 10 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 5 * 60 * 1000,
    structuralSharing: false,
    experimental_prefetchInRender: true,
  },
  noRetry: {
    retry: false,
  },
  oneTimeFetch: {
    gcTime: Infinity,
    staleTime: Infinity,
  },
  shortLived: {
    gcTime: 30 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
  },
} satisfies Record<string, OmitKeyof<QueryObserverOptions<unknown, DefaultError>, 'suspense' | 'queryKey'>>

const queryClient = new QueryClient({
  defaultOptions: { queries: queryPresets.longLivedWithSSdevalue },
})

export const vueQueryPluginOptions: VueQueryPluginOptions = {
  enableDevtoolsV6Plugin: true,
  queryClient,
}

export { queryClient, VueQueryPlugin }
